module.exports = __webpack_public_path__ + "static/img/introduceCType4.7677af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceCType4.png
// module id = 6RyT
// module chunks = 0